import ConsumerFeedback from './ConsumerFeedback';
import withModal from '../modal/withModal';

export const CONSUMER_FEEDBACK_MODAL = 'modal/CONSUMER_FEEDBACK';

export default withModal(ConsumerFeedback, {
  name: CONSUMER_FEEDBACK_MODAL,
  size: 'sm',
  type: 'full',
  dismissible: false,
  hideHeader: true,
  className: 'consumer-feedback-modal',
});
